{
  "header": {
    "name": "Name"
  },
  "empty": "Keine Sektoren gefunden",
  "button": {
    "new": "Neuer Sektor",
    "newSub": "Einen Untersektor hinzufügen",
    "update": "Sektor aktualisieren",
    "remove": "Sektor entfernen"
  },
  "label": "Sektor",
  "validation": {
    "required": "Pflichtfeld",
    "maxLength": "Maximale Länge: {maxLength}",
    "nameFormat": "Der Name muss folgende Zeichen enthalten [a-z, A-Z, 0-9, _, ., -]",
    "minLength": "Mindestlänge: {minLength}"
  },
  "details": {
    "tab": {
      "device": {
        "label": "S4 – lokale Station"
      },
      "application": {
        "label": "Anwendungen"
      },
      "user": {
        "label": "Benutzer"
      },
      "userGroup": {
        "label": "Benutzergruppen"
      },
      "dtwins": {
        "label": "Geräte"
      },
      "sectors": {
        "label": "Sektoren"
      }
    },
    "buttons": {
      "create": "Neuer Sektor",
      "createSubSector": "Einen Untersektor hinzufügen",
      "remove": "Sektor entfernen",
      "attach": {
        "application": "Eine Anwendung zuordnen",
        "device": "Ein Gerät zuordnen",
        "user": "Einen Benutzer zuordnen",
        "userGroup": "Eine Benutzergruppe zuordnen",
        "dtwins": "Ein Gerät zuordnen"
      },
      "detach": "Vom Sektor trennen",
      "details": "Details"
    },
    "currentSelection": "Aktuelle Auswahl"
  },
  "modals": {
    "create": {
      "title": "Einen neuen Sektor erstellen",
      "sector": {
        "label": "Name des Sektors",
        "description": "Beschreibung"
      }
    },
    "update": {
      "title": "Einen bestehenden Sektor aktualisieren",
      "sector": {
        "label": "Name des Sektors",
        "description": "Beschreibung"
      }
    },
    "remove": {
      "title": "Sektor {sectorName} entfernen",
      "description": "Möchten Sie diesen Sektor wirklich entfernen?",
      "notAllowed": "Die Löschung eines Sektors ist nicht möglich, einige Geräte sind ihm zugeordnet",
      "titleAlt": "Den Sektor löschen"
    },
    "confirmDetach": {
      "device": {
        "title": "Gerät vom Sektor trennen",
        "description": "Das Gerät „{name}“ wird vom Sektor „{sectorLabel}“ getrennt | Die folgenden Geräte werden vom Sektor „{sectorLabel}“ getrennt",
        "warning": "Das vom Sektor getrennte Gerät wird im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten). | Die vom Sektor getrennten Geräte werden im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten)."
      },
      "application": {
        "title": "Anwendung vom Sektor trennen",
        "description": "Die Anwendung „{name}“ wird vom Sektor „{sectorLabel}“ getrennt | Die folgenden Anwendungen werden vom Sektor „{sectorLabel}“ getrennt",
        "warning": "Die vom Sektor getrennte Anwendung wird im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten). | Die vom Sektor getrennten Anwendungen werden im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten)."
      },
      "user": {
        "title": "Benutzer vom Sektor trennen",
        "description": "Der Benutzer „{name}“ wird vom Sektor „{sectorLabel}“ getrennt | Die folgenden Benutzer werden vom Sektor „{sectorLabel}“ getrennt",
        "warning": "Die vom Sektor getrennten Benutzer haben keinen Zugriff mehr auf Visualisierung sowie Anwendungs- und Gerätemanagement. | Der vom Sektor getrennte Benutzer hat keinen Zugriff mehr auf Visualisierung sowie Anwendungs- und Gerätemanagement."
      },
      "userGroup": {
        "title": "Benutzergruppe vom Sektor trennen",
        "description": "Die Benutzergruppe „{name}“ wird vom Sektor „{sectorLabel}“ getrennt | Die folgenden Benutzergruppen werden vom Sektor „{sectorLabel}“ getrennt",
        "warning": "Die vom Sektor getrennten Benutzergruppen haben keinen Zugriff mehr auf Visualisierung sowie Anwendungs- und Gerätemanagement. | Die vom Sektor getrennte Benutzergruppe hat keinen Zugriff mehr auf Visualisierung sowie Anwendungs- und Gerätemanagement."
      },
      "errors": {
        "list_empty": "Sie müssen mindestens ein Element auswählen, um es zu trennen"
      },
      "dtwins": {
        "title": "Gerät vom Sektor trennen",
        "description": "Das Gerät „{name}“ wird vom Sektor „{sectorLabel}“ getrennt | Die folgenden Geräte werden vom Sektor „{sectorLabel}“ getrennt",
        "warning": "Das vom Sektor getrennte Gerät wird im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten). | Die vom Sektor getrennten Geräte werden im Verwaltungsbildschirm nicht mehr sichtbar sein (gemäß den Benutzerrechten)."
      }
    },
    "attach": {
      "device": {
        "title": "Geräte dem Sektor zuordnen",
        "description": "Überprüfen Sie die Geräte, die dem Sektor zugeordnet werden sollen"
      },
      "application": {
        "title": "Anwendungen dem Sektor zuordnen",
        "description": "Überprüfen Sie die Anwendungen, die dem Sektor zugeordnet werden sollen"
      },
      "user": {
        "title": "Benutzer einem Sektor zuweisen",
        "description": "Überprüfen Sie die Benutzer, die dem Sektor zugeordnet werden sollen"
      },
      "userGroup": {
        "title": "Benutzergruppen einem Sektor zuordnen",
        "description": "Überprüfen Sie die Benutzergruppen, die dem Sektor zugeordnet werden sollen"
      },
      "errors": {
        "list_empty": "Sie müssen mindestens ein Element auswählen, um es zuzuordnen"
      },
      "dtwins": {
        "description": "Überprüfen Sie die Geräte, die dem Sektor zugeordnet werden sollen",
        "title": "Geräte dem Sektor zuordnen"
      }
    },
    "view": {
      "title": "Einen Sektor anzeigen"
    }
  },
  "search": "Nach Namen suchen",
  "select": {
    "all": "Alle Sektoren auswählen",
    "selected": "Sektoren ausgewählt"
  },
  "treeview": {
    "actionsButton": {
      "title": "Aktionen"
    }
  },
  "selectedUsers": "Keine Benutzer ausgewählt | {count} Benutzer ausgewählt | {count} Benutzer ausgewählt",
  "selectedUserGroups": "Keine Gruppen ausgewählt | {count} Gruppe ausgewählt | {count} Gruppen ausgewählt"
}
